import { VariousConsts } from "@app/_core/constants/various-consts";
import { HttpResponse } from "../api/http-response.interface";
import { CurrentUser } from "./current-user.interface";
import { UserRole } from "./user-role";
export class AccountMapper {
	static mapCurrentUserResponse(response: HttpResponse<CurrentUser>): HttpResponse<CurrentUser> {
		return {
			status: response.status,
			data: {
				userId: response.data.userId,
				username: response.data.username,
				email: response.data.email,
				active: response.data.active,
				firstName: response.data.firstName,
				lastName: response.data.lastName,
				phone: response.data.phone,
				role: response.data.role,
				supplierId: response.data.supplierId,
				token: response.data.token,
				refreshToken: response.data.refreshToken,
			},
		};
	}

	// TODO debate if a separate entity for customer is necessary
	static mapCurrentCustomerUserResponse(response: HttpResponse<CurrentUser>): HttpResponse<CurrentUser> {
		return {
			status: response.status,
			data: {
				userId: 0,
				username: VariousConsts.NOT_AVAILABLE,
				email: VariousConsts.NOT_AVAILABLE,
				active: true,
				firstName: response.data.name,
				lastName: VariousConsts.NOT_AVAILABLE,
				phone: VariousConsts.NOT_AVAILABLE,
				role: UserRole.CUSTOMER,
				supplierId: VariousConsts.NOT_AVAILABLE,
				token: response.data.token,
				refreshToken: response.data.refreshToken,
			},
		};
	}
}
